// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2_2Cy","legacyBtn":"MutateMid_legacyBtn__2xQkn"};